import { Injectable } from '@angular/core'
import { DataFormatter } from '../util/DataFormatter'
import { FormatterFunction } from '../directives/format-view.directive'

@Injectable({
  providedIn: 'root',
})
export class ViewFormatterService {
  static numberToStringFormatter(value: number | string): string {
    return DataFormatter.numberToString(value)
  }

  static integerToStringFormatter(): FormatterFunction {
    return this.stringToLocaleNumberFormatter(DataFormatter.INTEGER_LOCALE_CONFIG)
  }

  static numberToLocaleStringFormatter(): FormatterFunction {
    return this.stringToLocaleNumberFormatter()
  }

  static currencyToLocaleStringFormatter(): FormatterFunction {
    return this.stringToLocaleNumberFormatter(DataFormatter.CURRENCY_LOCALE_CONFIG)
  }

  static stringToNumberFormatter(value: string): number {
    return DataFormatter.localeStringToNumber(value)
  }

  static stringToLocaleNumberFormatter(config = DataFormatter.NUMBER_LOCALE_CONFIG): FormatterFunction {
    return function (value: number | string): string {
      return DataFormatter.numberToLocaleString(value, config)
    } as FormatterFunction
  }
}
